import { Link } from 'react-router-dom';
import { hubs, services } from '../../utils/assets/main';

const Section03 = ({
  contentsRef,
}: {
  contentsRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <section className='section03 w-full' ref={contentsRef}>
      <div className='w-full pt-[30px] pb-[20px] px-[20px] relative'>
        <h3 className='text-[#2F46B8] font-[600] mb-[12px] text-[14px]'>
          협회 서비스
        </h3>
        <p className='text-[16px] leading-[25.6px] font-[600] whitespace-pre-line break-keep tiny:text-[15px]'>
          커뮤니티 활동과 결합된 영업의 가치를 높이는
          <br />
          프리미엄 인사이트를 제공합니다.
        </p>
        <div className='w-full mt-[30px] flex flex-col gap-[30px]'>
          <ul className='w-full flex flex-col justify-center items-center gap-[12px]'>
            <li className='w-full text-white flex flex-col gap-6'>
              <Link
                to='https://kodeal.fks.co.kr/talk'
                target='_blank'
                className='w-full flex justify-start items-start relative rounded-[10px] overflow-hidden min-h-[200px]'
              >
                <div className='w-full flex flex-col gap-[30px] justify-start items-start p-[20px] relative rounded-[10px] overflow-hidden min-h-[200px]'>
                  <img
                    src='/imgs/section03_li_bg.png'
                    alt=''
                    className='w-full h-full absolute left-0 top-0'
                  />
                  <div className='relative flex flex-col justify-start items-start gap-2 w-full'>
                    <div className='flex justify-start items-center text-[#1D3BD3] text-[16px] leading-[24px] font-[600]'>
                      코딜톡 바로가기
                      <img
                        src='/imgs/icons/circle-right-arrow.webp'
                        alt='우측 화살표'
                        className='h-[20px] object-contain ml-[4px]'
                      />
                    </div>
                    <div className='max-w-[265px] text-[14px] leading-[150%] w-full font-[400] text-[#000000] tiny:text-[13px] tiny:leading-[20.5px] tracking-[-0.025em]'>
                      소통과 정보 교류를 콘텐츠로 연결해
                      <br />
                      가치를 높이고 함께 성장합니다.
                    </div>
                  </div>

                  <ul className='flex flex-col gap-[10px] w-full'>
                    {services.map((service, index) => {
                      return (
                        <div
                          key={`service_${index}`}
                          className='bg-[#FFFFFFB2] backdrop-blur-[15px] border border-[#FFFFFF] rounded-[10px] h-[165px] p-5 relative s:pr-3 tiny:p-4'
                        >
                          <div className='text-[#222222] font-semibold text-[16px] mb-2 leading-[150%] tracking-[-0.025em]'>
                            {service.title}
                          </div>
                          <div className='text-[#555555] text-[14px] font-normal leading-[150%] tracking-[-0.025em] tiny:text-[12px]'>
                            {service.desc}
                          </div>
                          <div>
                            <img
                              src={service.img}
                              alt=''
                              className='w-[50px] h-[50px] absolute right-4 bottom-4'
                            />
                          </div>
                        </div>
                      );
                    })}
                  </ul>
                </div>
              </Link>
            </li>
            <li className='w-full text-white flex flex-col gap-6'>
              <div className='w-full flex flex-col gap-[30px] justify-start items-start p-[20px] relative rounded-[10px] overflow-hidden min-h-[200px]'>
                <img
                  src='/imgs/section03_li_hub_bg_m.png'
                  alt=''
                  className='w-full h-full absolute left-0 top-0'
                />
                <div className='relative flex flex-col justify-start items-start gap-2 w-full'>
                  <div className='flex justify-start items-center text-[#1D3BD3] text-[16px] leading-[24px] font-[600]'>
                    코딜허브
                  </div>
                  <div className='text-[14px] leading-[150%] w-full font-[400] text-[#000000] tiny:text-[13px] tiny:leading-[20.5px] tracking-[-0.025em]'>
                    가치를 확장하는 프리미엄 인사이트
                    <br />
                    영업인의 성장과 혜택을 지속적으로 생산·제공합니다.
                  </div>
                </div>

                <ul className='flex flex-col gap-[10px] w-full'>
                  {hubs.map((hub, index) => {
                    return (
                      <div
                        key={`service_${index}`}
                        className='bg-[#FFFFFFB2] backdrop-blur-[15px] border border-[#FFFFFF] rounded-[10px] h-[165px] p-5 relative s:pr-3 tiny:p-4'
                      >
                        <div className='text-[#222222] font-semibold text-[16px] mb-2 leading-[150%] tracking-[-0.025em]'>
                          {hub.title}
                        </div>
                        <div className='text-[#555555] text-[14px] font-normal leading-[150%] tracking-[-0.025em] tiny:text-[12px]'>
                          {hub.desc}
                        </div>
                        <div>
                          <img
                            src={hub.img}
                            alt=''
                            className='w-[50px] h-[50px] absolute right-4 bottom-4'
                          />
                        </div>
                      </div>
                    );
                  })}
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default Section03;
